import { z } from "zod/v4";

export const ShopifyMoneyV1Schema = z.object({
  amount: z.number().nonnegative(),
  currencyCode: z.string().length(3),
});

export type ShopifyMoneyV1 = z.infer<typeof ShopifyMoneyV1Schema>;

export const BillingPlanIntentRefV1Schema = z.object({
  planIntentId: z.uuid(),
  revision: z.number().int().positive(),
});

export type BillingPlanIntentRefV1 = z.infer<
  typeof BillingPlanIntentRefV1Schema
>;

export const BillingPlanIntentStateList = [
  "pending_capacity",
  "ready",
  "applied",
  "cancelled",
] as const;

export const BillingPlanIntentStateSchema = z.enum(BillingPlanIntentStateList);

export type BillingPlanIntentState = z.infer<
  typeof BillingPlanIntentStateSchema
>;

/**
 * Why a command terminated `record_only` without mutating the provider.
 * `recorded` alone cannot tell "nothing to do" from "the mutation is parked
 * behind a merchant approval", and only the latter needs an operator.
 */
export const BillingPlanDeferredReasonList = [
  "pending_capacity",
  "superseded_replay",
  "cancelled",
  "trial_commitment",
] as const;

export const BillingPlanDeferredReasonSchema = z.enum(
  BillingPlanDeferredReasonList
);

export type BillingPlanDeferredReason = z.infer<
  typeof BillingPlanDeferredReasonSchema
>;

export const BillingShopifyApprovalStatusList = [
  "requesting",
  "pending",
  "approved",
  "declined",
  "expired",
] as const;

export const BillingShopifyApprovalStatusSchema = z.enum(
  BillingShopifyApprovalStatusList
);

export type BillingShopifyApprovalStatus = z.infer<
  typeof BillingShopifyApprovalStatusSchema
>;

/**
 * `deferred_to_boundary` is a Plan Commitment: the plan is recorded, and its
 * Shopify approval may already be secured, but it applies only at the
 * revision's `applyAfterTs` (the trial's end, less a margin).
 */
export const BillingPlanExecutionDispositionSchema = z.enum([
  "apply_now",
  "await_capacity",
  "deferred_to_boundary",
]);

export type BillingPlanExecutionDisposition = z.infer<
  typeof BillingPlanExecutionDispositionSchema
>;

export const BillingShopifyApprovalActionSchema = z.enum([
  "none",
  "reuse_pending",
  "request",
]);

export type BillingShopifyApprovalAction = z.infer<
  typeof BillingShopifyApprovalActionSchema
>;
